import { LegalPage, LegalSection } from "@/components/Legal";
import { BETA_EMAIL } from "@/components/Layout";
import { Brand } from "@/components/Logo";

const EFFECTIVE = "June 2026";

export default function Security() {
  return (
    <LegalPage
      testId="security-page"
      title="Security"
      subtitle="Your relationships are personal. Here's how we work to keep them protected — without overclaiming."
      effectiveDate={EFFECTIVE}
    >
      <LegalSection title="Security overview">
        <p>
          <Brand /> is built with a privacy-first mindset. We aim to collect only the
          data needed to make the product useful, and to protect that data with modern
          security practices. As a beta product, our security program continues to evolve
          as we grow.
        </p>
        <p className="font-medium text-slate-700">We do not sell user data.</p>
      </LegalSection>

      <LegalSection title="Encryption and transport">
        <p>
          All traffic between your device and our service is encrypted in transit using
          HTTPS/TLS. Sensitive data is stored using modern security practices on protected
          infrastructure.
        </p>
      </LegalSection>

      <LegalSection title="Access controls">
        <p>
          Access to production systems and data is limited to authorized personnel and
          service providers who need it to operate and support the service. We follow the
          principle of least privilege and review access as the team and product grow.
        </p>
      </LegalSection>

      <LegalSection title="Hosting and infrastructure">
        <p>
          We host <Brand /> on reputable cloud infrastructure providers and rely on
          their physical and network security controls. Service providers are used strictly
          to operate the service and are expected to maintain appropriate safeguards.
        </p>
      </LegalSection>

      <LegalSection title="Backups and reliability">
        <p>
          We take reasonable measures to keep the service reliable and to protect against
          data loss. Our backup and reliability practices continue to mature as the product
          moves through beta.
        </p>
      </LegalSection>

      <LegalSection title="Google integrations" highlight>
        <p>
          Where Google integrations are enabled, data handling is governed by our{" "}
          <a className="text-blue-700 font-medium hover:underline" href="/privacy">
            Privacy Policy
          </a>{" "}
          and applicable Google API policies. We request only the minimum Google permissions
          necessary for the features you've enabled, and we never use Google user data for
          advertising or sell it to third parties.
        </p>
      </LegalSection>

      <LegalSection title="User control">
        <p>
          You stay in control of your data. You can update your information, disconnect
          connected services, and request deletion of your account and associated data at
          any time by contacting us.
        </p>
      </LegalSection>

      <LegalSection title="Responsible disclosure">
        <p>
          If you believe you've found a security issue, we'd genuinely like to hear from
          you. Please email{" "}
          <a className="text-blue-700 font-medium hover:underline" href={`mailto:${BETA_EMAIL}`}>
            {BETA_EMAIL}
          </a>{" "}
          with details so we can investigate and respond. Please give us a reasonable
          opportunity to address the issue before any public disclosure.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
